// Generated by scripts/generate-strategy-partner-assets.mjs

export interface CampaignImageCandidate {
  path: string;
  width: number;
}

export interface CampaignImageAsset {
  avif: readonly CampaignImageCandidate[];
  fallback: CampaignImageCandidate;
  height: number;
  jpeg: readonly CampaignImageCandidate[];
  sizes: string;
  width: number;
}

export const STRATEGY_PARTNER_IMAGES = {
  "bitwiseCover": {
    "avif": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-960.avif",
        "width": 960
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-1600.avif",
        "width": 1600
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-2560.avif",
        "width": 2560
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-3840.avif",
        "width": 3840
      }
    ],
    "fallback": {
      "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-3840.jpg",
      "width": 3840
    },
    "height": 1463,
    "jpeg": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-960.jpg",
        "width": 960
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-1600.jpg",
        "width": 1600
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-2560.jpg",
        "width": 2560
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-3840.jpg",
        "width": 3840
      }
    ],
    "sizes": "(min-width: 1504px) 1440px, 100vw",
    "width": 4095
  },
  "bitwiseMag7xCard": {
    "avif": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-mag7x-card-1e13741385f2-618.avif",
        "width": 618
      }
    ],
    "fallback": {
      "path": "/assets/strategy-partner/optimized/bitwise-mag7x-card-1e13741385f2-618.jpg",
      "width": 618
    },
    "height": 384,
    "jpeg": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-mag7x-card-1e13741385f2-618.jpg",
        "width": 618
      }
    ],
    "sizes": "(min-width: 1280px) 33vw, (min-width: 768px) 50vw, calc(100vw - 2rem)",
    "width": 618
  },
  "bitwiseRobotics": {
    "avif": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-robotics-card-590be81cfd8c-618.avif",
        "width": 618
      }
    ],
    "fallback": {
      "path": "/assets/strategy-partner/optimized/bitwise-robotics-card-590be81cfd8c-618.jpg",
      "width": 618
    },
    "height": 384,
    "jpeg": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-robotics-card-590be81cfd8c-618.jpg",
        "width": 618
      }
    ],
    "sizes": "(min-width: 1280px) 33vw, (min-width: 768px) 50vw, calc(100vw - 2rem)",
    "width": 618
  },
  "bitwiseUsAiLeaders": {
    "avif": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-us-ai-leaders-card-8dc7d15a2122-618.avif",
        "width": 618
      }
    ],
    "fallback": {
      "path": "/assets/strategy-partner/optimized/bitwise-us-ai-leaders-card-8dc7d15a2122-618.jpg",
      "width": 618
    },
    "height": 384,
    "jpeg": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-us-ai-leaders-card-8dc7d15a2122-618.jpg",
        "width": 618
      }
    ],
    "sizes": "(min-width: 1280px) 33vw, (min-width: 768px) 50vw, calc(100vw - 2rem)",
    "width": 618
  }
} as const satisfies Record<"bitwiseCover" | "bitwiseMag7xCard" | "bitwiseRobotics" | "bitwiseUsAiLeaders", CampaignImageAsset>;
